import React from 'react';
import { cn } from '@/lib/utils';

type PricingItemProps = {
	header: string;
	description?: string;
	amount: number;
	currency: string;
	className?: string;
	guestCount?: number
}

export const PricingItem = ({ header, description, amount, currency, className, guestCount }: PricingItemProps) => {
	return (
		<div className={cn('flex flex-col font-poppins text-white text-base leading-5 text-left border-b border-tablz-med-gray-1 pb-3', className)}>
			<div className="flex justify-between">
				<p>{header}</p>
				<p>{Number.isInteger(amount) ? amount : amount.toFixed(2)} {guestCount ? `x ${guestCount} guests` : null} <span className='uppercase'>{currency}</span></p>
			</div>
			{description && (
				<p className="w-[90%] text-tablz-text-gray-3 font-normal pt-1">
					{description}
				</p>
			)}
		</div>
	);
};